<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterAccountSiteOperatorOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
/>

@if (option === EAdvancedFilterOptions.IS_ANY_OF || option === EAdvancedFilterOptions.IS_NONE_OF) {
  <div class="advanced-filter__account-sites">
    <pp-filter-field-account-sites
      (ppOnValueChange)="applyAccountSitesFilters($event)"
      [ppPreviousSelectedAccounts]="selectedAccountSites"
    />
  </div>
}
